var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-card',[_c('v-card-text',[_c('site-locations-table',{attrs:{"siteLocations":_vm.siteLocations,"siteLocationsCount":_vm.siteLocationsCount,"isLoading":_vm.isLoading,"singleLineAddress":true},on:{"updateSiteLocations":function($event){return _vm.handleUpdateSiteLocations($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }